import TermTooltip from "./TermTooltip";

/**
 * Renders question text with glossary terms as tooltips.
 * terms: [{ phrase, definition }]
 */
export default function QuestionText({ text, terms = [], onAskTerm }) {
  if (!terms?.length) {
    return <span>{text}</span>;
  }

  let remaining = text || "";
  const parts = [];
  let key = 0;

  const sorted = [...terms].sort(
    (a, b) => (b.phrase?.length || 0) - (a.phrase?.length || 0)
  );

  while (remaining.length > 0) {
    let earliest = null;
    let matchPhrase = null;
    for (const t of sorted) {
      const phrase = t.phrase;
      if (!phrase) continue;
      const idx = remaining.toLowerCase().indexOf(phrase.toLowerCase());
      if (idx !== -1 && (earliest === null || idx < earliest)) {
        earliest = idx;
        matchPhrase = t;
      }
    }
    if (earliest === null || !matchPhrase) {
      parts.push(<span key={key++}>{remaining}</span>);
      break;
    }
    if (earliest > 0) {
      parts.push(<span key={key++}>{remaining.slice(0, earliest)}</span>);
    }
    const len = matchPhrase.phrase.length;
    const matchedText = remaining.slice(earliest, earliest + len);
    parts.push(
      <TermTooltip
        key={key++}
        phrase={matchPhrase.phrase}
        definition={matchPhrase.definition}
        onAskInGuide={onAskTerm}
      >
        {matchedText}
      </TermTooltip>
    );
    remaining = remaining.slice(earliest + len);
  }

  return <>{parts}</>;
}
